import { createInstance, dateReviver } from '@/api';
import { GeckoSpecificationClient, GeckoSpecificationSearchResultDto } from '@/api/backoffice/clients';
import { i18n } from '@/i18n';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';

export interface GeckoSpecificationDetailStoreState {
    detail?: GeckoSpecificationSearchResultDto;
    loading: boolean;
    notFound?: boolean;
}

export const client = new GeckoSpecificationClient('', createInstance(), dateReviver);

export const useGeckoSpecificationDetailStore = defineStore('configuration-gecko-specification-detail-store', {
    state: (): GeckoSpecificationDetailStoreState => ({
        detail: null,
        loading: false,
        notFound: false
    }),
    actions: {
        async search(specificationCode: string) {
            try {
                this.loading = true;
                this.detail = await client.search(specificationCode);
                this.notFound = false;
                return this.detail;
            } catch (error: any) {
                if (error.status === 404) {
                    this.notFound = true;
                } else {
                    useAlertStore().handleException(
                        i18n.global.t('geckospecification.error.search.title'),
                        error,
                        false
                    );
                }
            } finally {
                this.loading = false;
            }
        },
        clear() {
            this.detail = null;
            this.loading = false;
        }
    }
});
